import React, { useEffect, useMemo, useState } from "react";
import { FaChevronLeft, FaChevronRight, FaQuoteLeft, FaStar } from "react-icons/fa";
import "../styles/CalificacionesRocola.css";

const calificaciones = [
  {
    calificacion: 5,
    nombre: "Ana Lopez",
    comentario: "Excelente curso, me ayudo muchisimo.",
  },
  {
    calificacion: 4,
    nombre: "Juan Perez",
    comentario: "Muy bueno, aunque podria mejorar algunos detalles.",
  },
  {
    calificacion: 5,
    nombre: "Carlos Gomez",
    comentario: "Impresionante. Supero todas mis expectativas.",
  },
  {
    calificacion: 4,
    nombre: "Luisa Fernandez",
    comentario: "Un curso muy completo y bien estructurado.",
  },
  {
    calificacion: 5,
    nombre: "Maria Castillo",
    comentario:
      "El curso fue increible, me abrio muchas oportunidades laborales.",
  },
  {
    calificacion: 4,
    nombre: "Pedro Hernandez",
    comentario:
      "Muy completo y bien explicado, con practicas que ayudan a ganar confianza.",
  },
  {
    calificacion: 5,
    nombre: "Andrea Ramirez",
    comentario: "Me encanto. Todo estuvo claro, practico y aplicable.",
  },
  {
    calificacion: 4,
    nombre: "Ricardo Torres",
    comentario: "Gran experiencia, lo recomendaria a todos mis colegas.",
  },
];

const getVisibleTestimonials = (startIndex, visibleCount) =>
  Array.from({ length: visibleCount }, (_, offset) => {
    const index = (startIndex + offset) % calificaciones.length;
    return calificaciones[index];
  });

function CalificacionesRocola() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const visibleTestimonials = useMemo(
    () => getVisibleTestimonials(currentIndex, 3),
    [currentIndex]
  );

  useEffect(() => {
    if (isPaused) return undefined;

    const interval = window.setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % calificaciones.length);
    }, 6500);

    return () => window.clearInterval(interval);
  }, [isPaused]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % calificaciones.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + calificaciones.length) % calificaciones.length
    );
  };

  return (
    <section className="testimonials-section" id="calificaciones">
      <div className="container">
        <div className="testimonials-heading" data-aos="fade-up">
          <span>Historias de alumnos</span>
          <h2>Conoce las opiniones de nuestros estudiantes</h2>
          <p>
            La mejor prueba de una capacitacion es lo que sus alumnos pueden
            hacer despues. Estas experiencias reflejan claridad, practica y
            acompanamiento.
          </p>
        </div>

        <div
          className="testimonials-shell"
          data-aos="fade-up"
          data-aos-delay="120"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div className="testimonials-summary">
            <strong>4.6/5</strong>
            <span>Promedio de satisfaccion</span>
            <p>Opiniones de estudiantes que eligieron prepararse en Nican.</p>
          </div>

          <button
            className="testimonial-nav testimonial-nav-prev"
            onClick={prevSlide}
            type="button"
            aria-label="Opinion anterior"
          >
            <FaChevronLeft />
          </button>

          <div className="testimonials-grid">
            {visibleTestimonials.map((calificacion, index) => (
              <article
                className="testimonial-card"
                key={`${calificacion.nombre}-${currentIndex}-${index}`}
              >
                <FaQuoteLeft className="testimonial-quote" />
                <div className="testimonial-stars" aria-label={`${calificacion.calificacion} estrellas`}>
                  {Array.from({ length: 5 }).map((_, starIndex) => (
                    <FaStar
                      key={starIndex}
                      className={
                        starIndex < calificacion.calificacion
                          ? "star-filled"
                          : "star-empty"
                      }
                    />
                  ))}
                </div>
                <p>&ldquo;{calificacion.comentario}&rdquo;</p>
                <footer>{calificacion.nombre}</footer>
              </article>
            ))}
          </div>

          <button
            className="testimonial-nav testimonial-nav-next"
            onClick={nextSlide}
            type="button"
            aria-label="Opinion siguiente"
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
    </section>
  );
}

export default CalificacionesRocola;
